module.exports = new __parcel__URL__("jacked-the-outlaw-story-of-grand-theft-auto.c7c3a455.jpg").toString();